import Iconify from "../../iconify";
import IconCode from "@/src/lib/iconCode";

const ShowPriceWithIcon = ({ price, textColor, textSize }) => {
    return (
        <div className="flex flex-row items-center gap-0.5">
            {/* <Iconify
				icon={IconCode.rupeeBold}
				width={textSize == "text-xl" ? "20px" : "16px"}
			/> */}
            <p className={`${textColor} ${textSize}`}>₹</p>
            <p className={`${textColor} ${textSize} font-bold`}>{price}</p>
        </div>
    );
};
export default ShowPriceWithIcon;
